import { useEffect, useState } from "react";

// One-time, hard-coded maintenance window for the full-app maintenance page.
// 10 PM Aug 18, 2026 -> 1 AM Aug 19, 2026, Asia/Riyadh (UTC+3).
// Expressed in UTC so it evaluates the same regardless of the visitor's browser timezone.
export const MAINTENANCE_WINDOW_START = Date.UTC(2026, 7, 18, 19, 0, 0); // 22:00 Riyadh, Aug 18
export const MAINTENANCE_WINDOW_END = Date.UTC(2026, 7, 18, 22, 0, 0);   // 01:00 Riyadh, Aug 19

export const isInMaintenanceWindow = () => {
    const now = Date.now();
    return now >= MAINTENANCE_WINDOW_START && now < MAINTENANCE_WINDOW_END;
};

// Re-checks periodically so a tab left open flips into (and out of) the
// maintenance page automatically, without needing a manual refresh.
export const useMaintenanceWindow = (pollMs = 30 * 1000) => {
    const [inWindow, setInWindow] = useState(isInMaintenanceWindow());

    useEffect(() => {
        const interval = setInterval(() => {
            setInWindow(isInMaintenanceWindow());
        }, pollMs);
        return () => clearInterval(interval);
    }, [pollMs]);

    return inWindow;
};
